module.exports = __webpack_public_path__ + "img/TeamComic_024.dba62ebe.png";